import React from 'react';

const LVRLangenfeld = props => {
  return (
    <>
      <h2 style={{ fontWeight: 'bold' }}>Team / Hierarchie</h2>
      <p style={{ color: 'grey' }} className='profile-information-list'>
        <ul>
          <li>Duale Leitung (Chefärzte und Pflegedienstleitung)</li>
          <li>Jede Abteilung ist mit ltd. Oberärzten, Oberärzten, Fachärzten und Assistenzärzten besetzt</li>
          <li>Arbeit auf Station in multiprofessionellen Teams</li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold' }}>Arbeitszeitmodell</h2>
      <p style={{ color: 'grey' }} className='profile-information-list'>
        <ul>
          <li>Elektronische Zeiterfassung (mit Erfassung von Überstunden – Freizeitausgleich oder Auszahlung)</li>
          <li>Flexible Arbeitszeiten (übliche Kernarbeitszeit 9-15 Uhr)</li>
          <li>Alle Formen der Teilzeitarbeit möglich</li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold' }}>Weiterbildung</h2>
      <p style={{ color: 'grey' }} className='profile-information-list'>
        <ul>
          <li>Ausgezeichnetes Fort- und Weiterbildungsangebot incl. Selbsterfahrung</li>
          <li>Weiterbildung in der Arbeitszeit</li>
          <li>Komplette Weiterbildung incl. Neurologiejahr möglich</li>
          <li>Rotation ein bis zwei Mal im Jahr in Wunschbereiche (z. B. Allgemeinpsychiatrie, Gerontopsychiatrie, Abhängigkeitserkrankungen, Forensik, spezialisierte Ambulanzen)</li>
          <li>Neurologie Weiterbildung in der Klinik möglich</li>
          <li>EEG-Fortbildung</li>
          <li>LVR-Akademie auf dem Klinikgelände</li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold' }}>Einarbeitung</h2>
      <p style={{ color: 'grey' }} className='profile-information-list'>
        <ul>
          <li>Strukturierte Einarbeitung</li>
          <li>Patensystem</li>
          <li>Einarbeitungsseminar</li>
          <li>Basisseminare</li>
          <li>Einführungsseminar Innere</li>
          <li>Balintgruppe</li>
          <li>Interventionsseminar</li>
          <li>EDV-Schulung</li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold' }}>Dienste</h2>
      <p style={{ color: 'grey' }} className='profile-information-list'>
        <ul>
          <li>Dienste immer zu Zweit (zwei Assistenzärzt:innen)</li>
          <li>Keine 24std Dienste, geteilte Dienste am Wochende (Tag – und Nachtdienst)</li>
          <li>Erster Dienst erst nach drei Monaten</li>
          <li>Durchschnittlich 3 Dienste im Monat</li>
          <li>Oberärztlicher Hintergrunddienst (Oberärztliche Visitation der Neuaufnahmen am Wochenende)</li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold' }}>Fachliche Besonderheiten</h2>
      <p style={{ color: 'grey' }} className='profile-information-list'>
        <ul>
          <li>Behandlung für Menschen mit Erkrankungen aus dem gesamten Spektrum der Psychiatrie und Psychotherapie</li>
          <li>Neurostimulationsverfahren (rTMS, EKT)</li>
          <li>Einnahmen aus Gutachtentätigkeiten behält der:die Mitarbeiter:in</li>
          <li>Möglichkeit zur Promotion gegeben</li>
          <li>Komplette Weiterbildungsermächtigung incl. ein Jahr Neurologie gegeben</li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold' }}>Benefits</h2>
      <p style={{ color: 'grey' }} className='profile-information-list'>
        <ul>
          <li>Bezahlung etc nach TV VKA</li>
          <li>mögliche Teilnahme an Klinik-/LVR-internen Fort- und Weiterbildungen, auch über die Facharztweiterbildung hinaus</li>
          <li>Assistentensprecher:innen</li>
          <li>Fachbibliothek</li>
          <li>Rotation in alle Fachbereiche</li>
          <li>Möglichkeiten des Unterrichtens in der Pflegeschule</li>
          <li>Assistent:innen-Stammtisch</li>
          <li>Betriebliche Altersvorsorge</li>
          <li>Kinderbetreuung</li>
          <li>Gute Anbindung/Erreichbarkeit aus Ballungszentren (Köln, Leverkusen, Düsseldorf) hinsichtlich Öffentlicher Nahverkehr sowie Individualverkehr (Kostenfreie Parkmöglichkeiten auf Klinikgelände) </li>
          <li>Portal für Bildung von Mitfahrgelegenheiten</li>
          <li>Erstellung von Gutachten möglich (vollumfänglich bezahlt)</li>
        </ul>
      </p>
    </>
  );
};

export default LVRLangenfeld;
